import "./Footer.css";

export default function Footer() {
  return (
    <footer className="gc-footer">
      <div className="gc-footer-inner">
        <a href="/privacy" className="gc-footer-link">Privacy &amp; Data</a>

        <a
          href="https://discord.gg/z4xYfS2dsa"
          target="_blank"
          rel="noopener noreferrer"
          className="gc-footer-discord gc-footer-cta"
          aria-label="Join our Discord"
          title="Join our Discord"
          role="button"
        >
          <img src="/discord.png" alt="Discord" className="gc-discord-img" />
          <span className="gc-footer-contact">Questions or feedback? Join our Discord</span>
        </a>
        <div className="gc-footer-note">
          Not affiliated with Blizzard Entertainment, Caverns of Time or Warmane. Game content and materials are trademarks and copyrights of their respective publishers and licensors.
        </div>
      </div>
    </footer>
  );
}
